import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Droppable } from 'react-beautiful-dnd';
import PostIt from './postIt';
import { withStyles } from '@material-ui/core/styles';
import styles from '../../../../Styles';

const getListStyle = (isDraggingOver, dir) => ({
    background: isDraggingOver ? 'lightblue' : 'transparent',
    display: 'flex',
    flexWrap: 'wrap',
    padding: dir ? '0' : '15px',
    overflow: 'hidden',
    margin: '0',
    minHeight: '100px',
    width: '100%',
});

class DropArea extends Component {
  render() {
      return (                 
          <Droppable droppableId={this.props.id} direction={this.props.direction} isDropDisabled={this.props.disabled} direction={this.props.direction !== undefined ? this.props.direction : 'horizontal'} key={this.props.id}>
            {(provided, snapshot) => (
              <div ref={provided.innerRef} {...provided.droppableProps} style={getListStyle(snapshot.isDraggingOver, this.props.direction === 'vertical' ? true : false)}>
                {Object.keys(this.props.postits).sort().map((text, index) => (
                  <PostIt control={this.props.control} key={parseInt(text.replace('p', ''))} index={parseInt(text.replace('p', ''))} id={text} text={this.props.postits[text]} col={this.props.id} itemAction={this.props.itemAction}/>
                ))}
                {provided.placeholder}
              </div>
            )}
          </Droppable>        
      );
   
  }
}

DropArea.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(DropArea);
